export const EVENT_NAME = 'timestamp';
const FIFTEEN_SECONDS = 15 * 1000;
export class Events {
    static start() {
        if (!Events.started) {
            setInterval(Events.dispatch, FIFTEEN_SECONDS);
            Events.started = true;
        }
    }
    static dispatch() {
        Events.target.dispatchEvent(Events.event);
    }
}
Events.target = document.createElement('div');
Events.event = new Event(EVENT_NAME);
Events.started = false;
//# sourceMappingURL=events.js.map